import React from 'react';
import { styled } from "../../../stitches.config";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import useMediaQuery from '../../../helpers/useMediaQuery';

import Box from '../Box'

export default props => {

    const embedType = props.settings.b1.embed.type;
    //console.log("embed type: ", embedType)

    var settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        responsive: [
            {
                breakpoint: 996,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                }
            }
        ]
    };

    var settingsYouTube = {
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        responsive: [
            {
                breakpoint: 1310,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 996,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                }
            },
        ]
    };

    const isDesktop = useMediaQuery('bp4');

    return (
        <Wrapper>
            {embedType === "tiktok" &&
                <section className="container">
                    <WrapperScroll>
                        <Box {...props}
                            id="b1"
                            type="BEmbedCarousel"
                            settings={props.settings.b1}
                        />
                        <Box {...props}
                            id="b2"
                            type="BEmbedCarousel"
                            settings={props.settings.b2}
                        />
                        <Box {...props}
                            id="b3"
                            type="BEmbedCarousel"
                            settings={props.settings.b3}
                        />
                        {props.settings.b4?.embed &&
                            <Box {...props}
                                id="b4"
                                type="BEmbedCarousel"
                                settings={props.settings.b4}
                            />
                        }
                        {props.settings.b5?.embed &&
                            <Box {...props}
                                id="b5"
                                type="BEmbedCarousel"
                                settings={props.settings.b5}
                            />
                        }
                        {props.settings.b6?.embed &&
                            <Box {...props}
                                id="b6"
                                type="BEmbedCarousel"
                                settings={props.settings.b6}
                            />
                        }
                    </WrapperScroll>
                </section>
            }
            {(embedType === "youtube" || embedType === "onnetwork") &&
                <section className="container container-slider">
                    <WrapperSlider>
                        {isDesktop ?
                            <Slider {...settingsYouTube}>
                                <Box {...props}
                                    id="b1"
                                    type="BEmbedCarousel"
                                    settings={props.settings.b1}
                                />
                                <Box {...props}
                                    id="b2"
                                    type="BEmbedCarousel"
                                    settings={props.settings.b2}
                                />
                                <Box {...props}
                                    id="b3"
                                    type="BEmbedCarousel"
                                    settings={props.settings.b3}
                                />
                                <Box {...props}
                                    id="b4"
                                    type="BEmbedCarousel"
                                    settings={props.settings.b4}
                                />
                                {props.settings.b5?.embed &&
                                    <Box {...props}
                                        id="b5"
                                        type="BEmbedCarousel"
                                        settings={props.settings.b5}
                                    />
                                }
                                {props.settings.b6?.embed &&
                                    <Box {...props}
                                        id="b6"
                                        type="BEmbedCarousel"
                                        settings={props.settings.b6}
                                    />
                                }
                            </Slider>
                            :
                            <>
                                <Box {...props}
                                    id="b1"
                                    type="BEmbedCarousel"
                                    settings={props.settings.b1}
                                />
                                <Box {...props}
                                    id="b2"
                                    type="BEmbedCarousel"
                                    settings={props.settings.b2}
                                />
                                <Box {...props}
                                    id="b3"
                                    type="BEmbedCarousel"
                                    settings={props.settings.b3}
                                />
                                <Box {...props}
                                    id="b4"
                                    type="BEmbedCarousel"
                                    settings={props.settings.b4}
                                />
                                {props.settings.b5?.embed &&
                                    <Box {...props}
                                        id="b5"
                                        type="BEmbedCarousel"
                                        settings={props.settings.b5}
                                    />
                                }
                                {props.settings.b6?.embed &&
                                    <Box {...props}
                                        id="b6"
                                        type="BEmbedCarousel"
                                        settings={props.settings.b6}
                                    />
                                }
                            </>
                        }
                    </WrapperSlider>
                </section>
            }
        </Wrapper>
    );
}

const Wrapper = styled("div", {
    ".style--": {
        marginBottom: "15px",
        "@bp4": {
            marginBottom: "30px"
        }
    },
    ".container-slider": {
        "@media (max-width: 768px)": {
            width: "auto",
            padding: "0"
        }
    }
});

const WrapperSlider = styled("div", {
    display: "flex",
    flexDirection: "row",
    flexGrow: "2px",
    overflowX: "scroll",
    scrollbarWidth: "none",
    paddingTop: "15px",
    minHeight: "180px",

    "@media(min-width: 840px)": {
        minHeight: "200px",
    },

    "@bp4": {
        minHeight: "auto",
        display: "block",
        //overflowX: "hidden",
        overflowX: "visible",
        paddingTop: "0",
    },

    ".slick-slide": {
        position: "relative"
    },
    ".slick-track": {
        paddingTop: "10px"
    },
    ".slick-slide.slick-center .Main_wrap__260iu img, .slick-slide.slick-center a": {
        transform: "scale(1.1)",
        transition: "transform 500ms"
    },
    ".slick-slide .Main_wrap__260iu img, .slick-slide a": {
        transition: "transform 300ms",
        width: "inherit",
        objectFit: "cover"
    },
    ".slick-list": {
        paddingTop: "0px !important",
        paddingBottom: "30px !important",
        "@mobile": {
            ".slick-slide > div": {
                margin: "0 10px"
            }
        }
    },
    ".slick-arrow:before": {
        color: "$grayscale100",
    },
    ".slick-dots": {
        "li": {
            margin: "0",
            width: "18px",
            height: "9px",
            color: "#666",
            "&.slick-active": {
                button: {
                    "&:before": {
                        color: "#333",
                        opacity: 1,
                        "@bp4": {
                            borderRadius: "10px"
                        }
                    }
                }
            },
            button: {
                width: "9px",
                height: "9px",
                padding: "0",
                "&:before": {
                    width: "9px",
                    height: "9px",
                    fontSize: "9px",
                    lineHeight: "9px",
                    color: "#999",
                    opacity: 1,
                    "@bp4": {
                        borderWidth: "0px",
                        borderRadius: "10px"
                    }
                }
            }
        }
    },
});



const WrapperScroll = styled("div", {
    display: "flex",
    flexDirection: "row",
    flexGrow: "2px",
    overflowX: "scroll",
    scrollbarWidth: "none",
    paddingTop: "15px",
    minHeight: "180px",
    gap: "20px",

    "@bp4": {
        justifyContent: "space-between",
    },

    "@bp5": {
        gap: "0px",
    }
});
